import { Navigate } from "react-router-dom";
import { useReactiveVar } from "@apollo/client";
import { userDetailsVar } from "../lib/cache";
import { BoxProps } from "@chakra-ui/react";
import {
  AccountsAgencyPartnerChoices,
  AccountsUserRoleChoices,
} from "../graphql/generated";
import { BrandChoicesEnum } from "../graphqlExternal/generated";

interface PermissionsWrapperProps extends BoxProps {
  mustBeStaff?: boolean;
  allowedRoles?: AccountsUserRoleChoices[];
  agencyPartnerCheck?: boolean;
  allowedPartners?: AccountsAgencyPartnerChoices[];
  allowedAdvertisers?: BrandChoicesEnum[];
}

export const PermissionsWrapper = ({
  mustBeStaff = false,
  allowedRoles,
  agencyPartnerCheck = false,
  allowedPartners,
  allowedAdvertisers,
  children,
}: PermissionsWrapperProps) => {
  const currentUser = useReactiveVar(userDetailsVar);

  // Wait for currentUser
  if (!currentUser) {
    return <></>;
  }

  // Staff check
  if (mustBeStaff) {
    if (!currentUser.isStaff) {
      return <Navigate to={"/"} />;
    }
  }

  // Check if Advertiser is allowed
  // if (allowedAdvertisers && currentUser) {

  //   if ((!allowedAdvertisers.includes(currentUser.agency.name as BrandChoicesEnum) && !currentUser.isStaff)){
  //     return <Navigate to={"../"} />;
  //   }
  // }
  // Role check

  if (allowedRoles && currentUser) {
    if (!allowedRoles.includes(currentUser.role)) {
      return <Navigate to={"/"} />;
    }
  }

  if (allowedAdvertisers) {
    if (
      !currentUser.isStaff &&
      (!currentUser.agency ||
        !allowedAdvertisers.includes(
          currentUser.agency.name as BrandChoicesEnum
        ))
    ) {
      return <Navigate to={"/"} />;
    }
  }

  // Check if agency has a partner
  if (agencyPartnerCheck) {
    if (!currentUser.agency.partner && !currentUser.isStaff) {
      return <Navigate to={"/"} />;
    }
  }

  // Check if partner is not NewsUK
  if (allowedPartners && currentUser) {
    if (
      !allowedPartners.includes(currentUser.agency.partner) &&
      !currentUser.isStaff
    ) {
      return <Navigate to={"../../"} />;
    }
  }
  return <>{children}</>;
};
